
document.addEventListener('shopify:section:load', initslide);
document.addEventListener('shopify:section:unload', initslide);

initslide();

function initslide() {
  var jq = window.jQuery;
  if (!jq || !jq.fn || typeof jq.fn.slick !== 'function') return;

  var sliders = jq('.amz-trustpilot-slider-home').not('.slick-initialized');
  if (!sliders.length) return;

  sliders.slick({
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: '200px',
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev amztp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next amztp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          centerMode: true,
          centerPadding: '100px',
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          centerMode: true,
          arrows: false,
          centerPadding: '50px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
function swiperinitialized() {
  if (typeof window.Swiper !== 'function') return;

  var el = document.querySelector('.myvideoSwiper');
  if (!el || el.swiper) return;

  var swiper = new window.Swiper(el, {
      slidesPerView: 5.3,
      spaceBetween: 4,
      freeMode: true,
      loop: false,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          hideOnClick: false,
          disabledClass: "swiper-button-disabled",
          lockClass: "swiper-button-lock"          
      }
  });
}
function showNextDate() {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayName = days[tomorrow.getDay()];
  const date = tomorrow.getDate();

  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return 'th';
    switch (n % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const formattedDate = `${dayName} ${date}${getOrdinal(date)}`;
  const target = document.getElementById('amznextDate');
  if (target) target.textContent = formattedDate;
}

document.addEventListener('DOMContentLoaded', showNextDate);


function randomInventoryNumber(min, max) {
  const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
  const mvistrElements = document.querySelectorAll('.amzrandomInven');
  mvistrElements.forEach(el => {
    el.textContent = randomNum;
  });
}

function initializereviewsliderHome() {
    var jq = window.jQuery;
    if (!jq || !jq.fn || typeof jq.fn.slick !== 'function') return;

    var sliders = jq('.amz-reviews-slider-slider-home').not('.slick-initialized');
    if (!sliders.length) return;

    sliders.slick({
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: true,
      centerPadding: '200px',
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      prevArrow:"<button type='button' class='slick-prev amztp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
      nextArrow:"<button type='button' class='slick-next amztp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            centerMode: true,
            centerPadding: '50px',
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: true,
            arrows: false,
            centerPadding: '50px',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  function initVideosSlider(){
    var jq = window.jQuery;
    if (!jq || !jq.fn || typeof jq.fn.slick !== 'function') return;

    var sliders = jq('.amz-video-slider-block').not('.slick-initialized');
    if (!sliders.length) return;

    sliders.slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 5,
    pauseOnHover: true,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 5000,
    dots: false,
      responsive: [ 
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
        {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  }

function initUpsellSlider() {
  if (typeof window.Swiper !== 'function') return;

  var el = document.querySelector('.amzUpsellSlider');
  if (!el || el.swiper) return;

  var swiper = new window.Swiper(el, {
    slidesPerView: 1,
    grid: {
      rows: 2,
      fill: "row",
    },
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
} 